import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  SafeAreaView,
  Linking,
  Image,
  Platform,
} from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { useTheme } from '../screens/ThemeContext';

const StatusBar = Platform.OS === 'web' ? () => null : require('react-native').StatusBar;

const AboutScreen = ({ navigation }) => {
  const { theme } = useTheme();

  const copyrightSection = {
    // icon: <AntDesign name="copyright" size={20} color={theme.primary} />,
    title: "App développé par Mhd Almouchafaou",
    subtitle: "Voir le portfolio",
    action: () => Linking.openURL('https://mhd-almouchafaou.onrender.com')
  };

  const renderInfoItem = (icon, title, subtitle) => (
    <View style={[styles.infoItem, { backgroundColor: theme.surface, borderColor: theme.border }]}>
      <View style={[styles.iconContainer, { backgroundColor: theme.background }]}>
        <MaterialCommunityIcons name={icon} size={24} color={theme.primary} />
      </View>
      <View style={styles.infoContent}>
        <Text style={[styles.infoTitle, { color: theme.text }]}>{title}</Text>
        <Text style={[styles.infoSubtitle, { color: theme.textSecondary }]}>
          {subtitle}
        </Text>
      </View>
    </View>
  );

  const renderLink = (icon, title, onPress) => (
    <TouchableOpacity
      style={[styles.linkItem, { backgroundColor: theme.surface, borderColor: theme.border }]}
      onPress={onPress}
    >
      <View style={styles.linkContent}>
        <MaterialCommunityIcons name={icon} size={24} color={theme.primary} />
        <Text style={[styles.linkText, { color: theme.text }]}>{title}</Text>
      </View>
      <MaterialCommunityIcons
        name="chevron-right"
        size={24}
        color={theme.textSecondary}
      />
    </TouchableOpacity>
  );

  const privacyPolicyUrl = 'https://startling-valkyrie-184d24.netlify.app/';

  return (
    <SafeAreaView style={[styles.safeArea, { backgroundColor: theme.background }]}>
      <StatusBar barStyle={theme.statusBar} backgroundColor={theme.background} />

      {/* Header */}
      <View style={[styles.header, { backgroundColor: theme.background }]}>
        <TouchableOpacity 
            onPress={() => navigation.goBack()}
            style={[styles.backButton, { backgroundColor: theme.surface, borderColor: theme.border }]}
          >
            <MaterialCommunityIcons 
              name="arrow-left" 
              size={24} 
              color={theme.primary} 
            />
        </TouchableOpacity>
        <Text style={[styles.headerTitle, { color: theme.text }]}>
        À propos
        </Text>
      </View>

      <ScrollView
        style={styles.container}
        showsVerticalScrollIndicator={false}
      >
        {/* App Info Section */}
        <View style={styles.appInfo}>
          <View style={[styles.logoContainer, { backgroundColor: theme.surface, borderColor: theme.border }]}>
            <Image
              source={{ uri: 'https://firebasestorage.googleapis.com/v0/b/myconcours-ec9cb.firebasestorage.app/o/IconMyConcour.png?alt=media&token=53068f3d-e4b8-4d7f-8589-691739a4e136' }}
              style={styles.logo}
            />
          </View>
          <Text style={[styles.appName, { color: theme.text }]}>MyConcours</Text>
          <Text style={[styles.appVersion, { color: theme.textSecondary }]}>
            Version 1.0.3
          </Text>
        </View>

        {/* App Details */}
        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: theme.text }]}>
            Informations
          </Text>
          {renderInfoItem(
            'information',
            'À propos de MyConcours',
            'Application dédiée à la préparation des concours au Cameroun'
          )}
          {renderInfoItem(
            'update',
            'Dernière mise à jour',
            'Mai 2024'
          )}
          {renderInfoItem(
            'shield-check',
            'Licence',
            'Tous droits réservés'
          )}
          {renderInfoItem(
            'alert-circle-outline',
            'Clause de non-responsabilité',
            "Cette application n’est liée à aucune autorité publique. Les contenus sont fournis à titre informatif uniquement."
          )}
        </View>

        {/* Liens utiles */}
        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: theme.text }]}>
            Liens utiles
          </Text>
          {renderLink('web', 'Site web', () =>
            Linking.openURL('https://www.cameroondeskacademy.com')
          )}
          {renderLink('scale-balance', 'Conditions d\'utilisation', () => navigation.navigate('TermsOfServiceScreen'))}
          {renderLink('shield-lock', 'Politique de confidentialité', () => Linking.openURL(privacyPolicyUrl))}
          {/* {renderLink('star', 'Noter l\'application', () => {})}
          {renderLink('share-variant', 'Partager l\'application', () => {})} */}
        </View>

        {/* Contact Section */}
        <View style={styles.section}>
          <Text style={[styles.sectionTitle, { color: theme.text }]}>
            Contact
          </Text>
          {renderLink('email', 'jobs@cameroondesks.com', () =>
            Linking.openURL('mailto:jobs@cameroondesks.com')
          )}
          {renderLink('phone', '+237 691 28 61 36', () =>
            Linking.openURL('tel:+237691286136')
          )}
          {renderLink('whatsapp', 'WhatsApp', () =>
            Linking.openURL('https://wa.me/237671454061')
          )}
        </View>

        {/* Credits */}
        <View style={[styles.creditsContainer, { backgroundColor: theme.surface, borderColor: theme.border }]}>
          
          <Text style={[styles.creditsText, { color: theme.textSecondary }]}>
            © 2024 MyConcours. Tous droits réservés.
          </Text>
          <TouchableOpacity style={[styles.portfolio]} onPress={copyrightSection.action}>
          <Text style={[styles.portfolioText, { color: theme.primary }]}>
           {copyrightSection.title}
          </Text>
          </TouchableOpacity>
        </View>

        <View style={styles.bottomSpace} />
      </ScrollView>
      <View style={[styles.bottomSpace, {flex: 1}, { backgroundColor: theme.background }]} />
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(0, 0, 0, 0.1)',
  },
  backButton: {
    padding: 8,
    marginRight: 16,
    borderRadius: 12,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  container: {
    flex: 1,
  },
  appInfo: {
    alignItems: 'center',
    padding: 20,
  },
  logoContainer: {
    width: 100,
    height: 100,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 15,
    borerWidth: 1,
  },
  logo: {
    width: 70,
    height: 70,
    // borderRadius: 15,
  },
  appName: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  appVersion: {
    fontSize: 16,
  },
  section: {
    padding: 20,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 15,
  },
  infoItem: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 15,
    borderRadius: 12,
    marginBottom: 10,
    // borderWidth: 1,
  },
  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: 20,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 15,
  },
  infoContent: {
    flex: 1,
  },
  infoTitle: {
    fontSize: 16,
    fontWeight: '600',
    marginBottom: 4,
  },
  infoSubtitle: {
    fontSize: 14,
  },
  linkItem: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 15,
    borderRadius: 12,
    marginBottom: 10,
    borderWidth: 1,
  },
  linkContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  linkText: {
    fontSize: 16,
    marginLeft: 15,
  },
  creditsContainer: {
    padding: 20,
    alignItems: 'center',
    marginHorizontal: 20,
    borderRadius: 12,
    // borderWidth: 1,
  },
  creditsText: {
    fontSize: 14,
    textAlign: 'center',
    marginVertical: 2,

  },
  bottomSpace: {
    height: 40,
  },
  portfolioText: {
    fontSize: 14,
    textAlign: 'center',
    marginVertical: 2,
    textDecorationLine: 'underline',
    
  },
});

export default AboutScreen;